/** @jsx jsx */

import React, {
  ReactElement,
  useRef,
  useCallback,
  useEffect,
  useLayoutEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import isEDGE from 'services/isEDGE';

interface FaceProps {
  id: string;
  face: string;
  color: string;
  textColor: string;
  alignTextTop: boolean;
  zIndex: number;
  transform: string;
  visibleFace: string;
  visibility: boolean;
  children: ReactElement;
}

const Face = ({
  id,
  face,
  color,
  textColor,
  alignTextTop,
  zIndex,
  transform = '',
  visibleFace,
  visibility,
  children,
  ...props
}: FaceProps) => {
  //

  const { opacity } = props as any;
  const faceElement: any = useRef(null);
  const anchors: any = useRef(undefined);

  useEffect(() => {
    const stopPropagation = e => {
      e.stopPropagation();
    };

    const addRemoveStopPropagation = addRemove => {
      if (anchors.current && anchors.current.length) {
        anchors.current.forEach((a: any) => {
          // console.log(`addRemoveStopPropagation('${addRemove}');`, a);
          a[`${addRemove}EventListener`]('click', stopPropagation);
        });
      }
    };

    if (!anchors.current) {
      anchors.current = Array.from(faceElement.current.querySelectorAll('a'));
      addRemoveStopPropagation('add');
    }

    return () => {
      addRemoveStopPropagation('remove');
    };
  }, []);

  useEffect(() => {
    if (anchors.current && anchors.current.length) {
      anchors.current.forEach((a: any) => {
        a.style.visibility = ['all', face].includes(visibleFace)
          ? 'visible'
          : 'hidden';
      });
    }
  }, [visibleFace]);

  return (
    <div
      ref={faceElement}
      id={id}
      className="flipCardFace"
      css={css`
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;

        // overflow: hidden;

        ${children.props.child === 0 &&
          `
          padding: ${window.dev() ? '10px' : '20px'};
          ${alignTextTop && 'align-items: flex-start;'}
        `}

        -webkit-backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        backface-visibility: hidden;

        white-space: pre-wrap;
        overflow-wrap: break-word;

        background-color: ${color};
        color: ${textColor};
        color: #fff;
        z-index: ${zIndex};
        border-radius: 10px;
        overflow: hidden;

        ${isEDGE() && `opacity: ${!opacity ? 1 : 0};`}

        ${transform &&
          `transform: ${transform};`}
        transition: opacity 0.2s, transform 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);

        -webkit-transform-style: preserve-3d;
        transform-style: preserve-3d;

        box-shadow: 0 8px 24px 5px rgba(0, 0, 0, 0.2);

        * {
          line-height: 1.2em;
        }

        //double up needed for editing. . .
        * div {
          color: ${textColor};
        }
      `}
      aria-label={face}
      aria-hidden={!visibility}
    >
      {children}
    </div>
  );
};

export default Face;
